import { FC } from 'react';

import {
  useProcessedBannerStore,
  useProcessedProblems,
  useProcessedWorkStore,
} from '../../../studentApp/hooks';
import { problemStore } from '../../../studentApp/stores';
import { BOX_SHADOW_REGION } from '../../constants';
import { squareGroupsStyle } from '../util/constants';

import { LabelAndSquares } from './labelAndSquares';
import { RegionLabel } from './regionLabel';

export const ExamCorrectionsRegion: FC = () => {
  const { examCorrectionsProblems } = useProcessedProblems();
  const selectedId = problemStore(state => state.selectedID);
  const progress = useProcessedWorkStore().examErrorsFixedProgress;
  const selectedProblem = examCorrectionsProblems.find(
    p => p.id === selectedId
  );
  const labelText = selectedProblem ? '#' + selectedProblem.number : '';
  const themeColor = useProcessedBannerStore().themeColor;

  return (
    <>
      <RegionLabel
        text={'Exam Corrections'}
        score={progress}
        id="fixExamErrorsProgress"
      />
      <div
        className="scrollable"
        style={{
          ...squareGroupsStyle,
          maxHeight: '82px',
          boxShadow: `${BOX_SHADOW_REGION} ${themeColor}`,
        }}
      >
        <LabelAndSquares text={labelText} problems={examCorrectionsProblems} />
      </div>
    </>
  );
};
